import React from "react";
import { Button, Result } from "antd";
import { messageType, showMessages } from "../helpers/message";

const PageNotFound = () => {
    React.useEffect(() => {
        showMessages('Record not found', messageType.error);
        if (window.location.pathname !== '/404') window.location.replace('/404');
    }, []);

    return (
        <div>
            <Result
                status="404"
                title="404"
                subTitle="Sorry, the page you visited does not exist."
                extra={<a href="/"><Button type="primary">Go Back</Button></a>}
            />
        </div>
    );
};

export default PageNotFound;
